import {Component, Inject, OnInit} from '@angular/core';
import {IdexService} from '../../idex.service';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {ConfirmCertificateSiteComponent} from '../confirm-certificate-site/confirm-certificate-site.component';
import { Mimetype } from 'app/shared/mimetype';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { SocialLogin } from 'app/account/social-login';
import {Toast} from '../../shared/toast/toast';

declare let $: any;

@Component({
  selector: 'app-export-task-dialog',
  templateUrl: './export-task-dialog.component.html',
  styleUrls: ['./export-task-dialog.component.css'],
  animations: [
   trigger('state', [
      state('collapse', style({height: 0})),
      state('expand', style({height: '*'})),
      transition('collapse => expand', animate('400ms ease-in')),
      transition('expand => collapse', animate('400ms ease-out'))
   ])
]
})
export class ExportTaskDialogComponent implements OnInit {
   private parent_folder: string;
   private path: string;
   public pathSelect: string;
   user: any;
   selectId: any;
   item: any;
   private tin: string;
   private selectedItemPath: any;
   isEnable = false;
   pathSite: string;
   private confirmSite: MatDialogRef<ConfirmCertificateSiteComponent>;

   onedriveExport = false;
   zDoxExport = false;
   googleExport = false;
   dropboxExport = false;
   loading = false;
   oneDriveList: any[] = [];
   access_token:any
   isSelect: boolean;
   selectedItem: any;
   googleList: any[] = [];
   dropboxList: any[] = [];
   drivePath: string;
   folderMimeType: string = 'application/vnd.google-apps.folder';
   private pageToken: string;
   private size = 0;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private service: IdexService, public dialog: MatDialog, private socialLogin:SocialLogin, public toast: Toast) {
     this.user = this.service.user;
     this.onedriveExport = data.onedriveExport;
     this.zDoxExport = data.zDoxExport;
     this.googleExport = data.googleExport;
     this.dropboxExport = data.dropboxExport;
  }

  ngOnInit() {
      if (!this.onedriveExport && !this.googleExport && !this.dropboxExport) { //set default My files
          this.parent_folder = this.user.homeNodeRef;
          this.pathSelect = 'Files/';
      } else if (this.onedriveExport) {
         this.loading = true;
         this.pathSelect = '';
         this.access_token = localStorage.getItem('access_token');
         if (this.access_token) {
            this.showDocumentOneDrive();
         } else {
            this.signinAndCheckCallBackOneDrive();
         }
      } else if (this.googleExport) {
         this.loading = true;
         this.pathSelect = '';
         this.drivePath = 'root';
         this.access_token = sessionStorage.getItem('access_token_google');
         if (this.access_token) {
            this.showDocumentGoogle();
         } else {
            this.signInGoogle()
         }
      } else if (this.dropboxExport) {
         this.pathSelect = '';
         this.loading = true;
         this.access_token = localStorage.getItem('access_token_dropbox');
         if (this.access_token) {
            this.showDocumentDropBox();
         } else {
            this.socialLogin.withDropBox().subscribe(result => {
               this.access_token = localStorage.getItem("access_token_dropbox");
               this.showDocumentDropBox();
            }, error => {
               this.data.toast.error(error);
            });
         }
      }
  }

   showDocumentGoogle() {
      this.service.getGoogleDriveList(this.drivePath, this.access_token, this.size, this.pageToken)
         .subscribe(res => {
            const data = JSON.parse(res);
            this.googleList = this.filterItems(data.files, this.folderMimeType);
            this.loading = false;
         },error => {
            setTimeout(() => {
               this.data.toast.error(error.message)
            }, 0);
            this.data.data.exportDialog.close();
         })
   }

   signInGoogle(){
      this.loading = true;
      this.socialLogin.withGoogle().subscribe(result => {
         this.access_token = sessionStorage.getItem('access_token_google');
         this.showDocumentGoogle();
      }, error => {
         this.data.toast.error(error);
         this.data.data.exportDialog.close();
      });
   }

   filterItems(arr, query) {
      return arr.filter((el) => el.mimeType.toLowerCase() === query.toLowerCase());
   }


   submitPath() {
      if(this.onedriveExport || this.zDoxExport || this.googleExport || this.dropboxExport){
         this.data.data.exportDialog.close({ pathSelect : this.pathSelect, pathId: this.parent_folder ,token:this.access_token});
      }else{
         let path = this.pathSelect.split('/');
         if(this.pathSite!==path[0]){
            this.confirmSite = this.dialog.open(ConfirmCertificateSiteComponent, {
               disableClose: true,
               data: this
            });

            this.confirmSite.componentInstance.pathSelect = this.pathSelect;

            this.confirmSite.afterClosed().subscribe((result) => {
               if (result) {
                  this.data.data.exportDialog.close({ pathSelect : this.pathSelect, pathId: this.parent_folder});
               }
            });
         } else {
            this.data.data.exportDialog.close({ pathSelect : this.pathSelect, pathId: this.parent_folder});
         }
      }

   }

   onSelectPath(agreed: any) {
      if(agreed === 'root'){
         this.parent_folder = "root";
         this.path = agreed.name;
         this.isEnable = true;
         return;
      }
      this.parent_folder = agreed.id;
      this.path = agreed.name;
      this.isEnable = true;
   }

   expand(folders: any) {
      if (!folders.isExpanded()) {
         folders.toggle();
      }
   }
   selectItem(item: any, parentFolder) {
      this.isEnable = true;
      $('.selectedPath').removeClass('selectedPath');
      if (item.tin) {
         $('#move' + item.tin).addClass('selectedPath');
      } else {
         $('#mainfile').addClass('selectedPath');
      }
      this.tin = item.tin;
      this.path = item.name ? item.name : item.srcElement.innerText || item.target.innerText;
      this.parent_folder = parentFolder;
      if (this.selectedItemPath === item) { return; }
      if (this.selectedItemPath) {
         this.selectedItemPath.selected = false;
      }
      this.selectedItemPath = item;
      item.selected = true;
      if (!this.path) {
         this.path = 'Files';
      }
   }

   select() {
         $('.selectedPath').removeClass('selectedPath');
         $('#link_work_one_drive_root').addClass('selectedPath');
         $('#link_work_dropbox_root').addClass('selectedPath');
         $('#link_work_google_root').addClass('selectedPath');
   }

   getPath(data) {
     this.pathSelect = data;
   }


   oneDriveIsFolder(item: any): boolean {
      return Boolean(!item.file)
   }

   getIconOneDrive(item: any): string {
      return Mimetype.getIconOneDrive(item);
   }


   showDocumentOneDrive(){
      this.service.onedriveFolders(this.access_token).subscribe(
         res => {
            this.oneDriveList = res.value;
            this.loading = false;
         },error => {
            this.handleErrorOnedrive(error);
         })
   }

    handleErrorOnedrive(error): void {
      if (error.status === 401 && error.error) {
        if (error.error.innerError) {
          this.handleUnauthorizedError();
        } else {
          this.handleErrorAndCloseDialog(error.message);
        }
      } else {
        this.handleErrorAndCloseDialog(error.message);
      }
    }

    private handleUnauthorizedError(): void {
         this.loading = true;
         this.pathSelect = '';
         this.isEnable = false;
         this.signinAndCheckCallBackOneDrive();
    }

    private handleErrorAndCloseDialog(errorMessage: string): void {
      setTimeout(() => {
         this.data.toast.error(errorMessage)
      }, 0);
      this.data.data.exportDialog.close()
    }



   signinAndCheckCallBackOneDrive(){
      this.loading = true;
      this.socialLogin.withMicrosoft().subscribe(result => {
         this.access_token = localStorage.getItem("access_token")
         if(this.access_token){
            this.showDocumentOneDrive();
         }else{
            this.data.data.exportDialog.close()
         }
      }, error => {
         this.data.toast.error(error);
         this.data.data.exportDialog.close()
      });
   }

   showDocumentDropBox(){
      this.service.getListFileDropbox(this.access_token,'').subscribe(
         res => {
            this.dropboxList = res.entries;
            this.loading = false;
         },error => {
            this.signinAndCheckCallBackDropBox()
         })
   }

   signinAndCheckCallBackDropBox(){
      this.loading = true;
      this.socialLogin.withDropBox().subscribe(result => {
         this.access_token = localStorage.getItem("access_token_dropbox");
         this.showDocumentDropBox();
      }, error => {
         this.data.toast.error(error);
         this.data.data.exportDialog.close()
      });
   }

   dropBoxIsFolder(item: any): boolean {
      return Boolean(item.mimeType === 'application/octet-stream');
   }

   replaceIdOneDrive(id): String {
      return id.replace( "!","_");
   }

   replaceIdDropBox(id): string {
      return id.replaceAll("/","_").replaceAll(" ","_");
   }

}
